import { NotificationType } from '@/client/services/api/graphql/gql/graphql';
import { useTranslation } from 'react-i18next';

export const useAssignmentNotificationBuilder = () => {
  const { t } = useTranslation();

  const notificationTypeOptions = [
    {
      label: t('notifications.type.newAssignment.assignee'),
      value: NotificationType.AssignmentCreatedAssignee,
    },
    {
      label: t('notifications.type.newAssignment.escalator'),
      value: NotificationType.AssignmentCreatedEscalator,
    },
    {
      label: t('notifications.type.reminder.assignee'),
      value: NotificationType.AssignmentReminderAssignee,
    },
    {
      label: t('notifications.type.reminder.escalator'),
      value: NotificationType.AssignmentReminderEscalator,
    },
    {
      label: t('notifications.type.assignmentCompletion.assignee'),
      value: NotificationType.AssignmentPassedAssignee,
    },
    {
      label: t('notifications.type.assignmentCompletion.escalator'),
      value: NotificationType.AssignmentPassedEscalator,
    },
    {
      label: t('notifications.type.overdue.assignee'),
      value: NotificationType.AssignmentOverdueAssignee,
    },
    {
      label: t('notifications.type.assignmentFailed.assignee'),
      value: NotificationType.AssignmentFailedAssignee,
    },
    {
      label: t('notifications.type.assignmentFailed.escalator'),
      value: NotificationType.AssignmentFailedEscalator,
    },
  ];

  const channelTypeTranslationMap: { [key: string]: string } = {
    email: t('notifications.channel.email'),
    in_app: t('notifications.channel.inApp'),
    slack: t('notifications.channel.slack'),
  };

  return {
    notificationTypeOptions,
    channelTypeTranslationMap,
  };
};
